import routes from '@modules/program/program-routes';
import store from '@modules/program/program-store';

export default {
  routes,
  store,
};
